"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const bridge_1 = require("@completeanatomy/bridge");
const ui_1 = require("@completeanatomy/ui");
const styled_components_1 = __importDefault(require("styled-components"));
function TipsItem({ title, link }) {
    const bridge = (0, bridge_1.useBridge)();
    const onClick = () => {
        bridge === null || bridge === void 0 ? void 0 : bridge.openURL({ link });
    };
    return ((0, jsx_runtime_1.jsxs)(Container, { onClick: onClick, children: [(0, jsx_runtime_1.jsx)(Title, { children: title }), (0, jsx_runtime_1.jsx)(StyledIcon, { name: ui_1.Icons.Help_Item_Open_Link, width: 30, height: 30, color: ui_1.darkTheme.designSystem.textSecondary })] }));
}
exports.default = TipsItem;
const Container = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: space-between;

  width: 100%;
  height: 70px;

  border-bottom: 1px solid ${({ theme }) => theme.tips.itemBorder};

  &:last-child {
    border-bottom: none;
  }
`;
const Title = styled_components_1.default.div `
  font-size: 1.2em;
  color: ${({ theme }) => theme.designSystem.textSecondary};
  margin-left: 40px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
const StyledIcon = (0, styled_components_1.default)(ui_1.Icon) `
  margin-right: 40px;
`;
